/**
 * @generated SignedSource<<b0c76c014f45e67071ed29ab41a896e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueFocusScreen_widgetIssueOverview$data = {
  readonly id: string;
  readonly issues: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"IssueFocusDetailComponent_issue" | "IssueImagePreloader_issues" | "WidgetIssueOverviewList_issue">;
  }>;
  readonly " $fragmentType": "IssueFocusScreen_widgetIssueOverview";
};
export type IssueFocusScreen_widgetIssueOverview$key = {
  readonly " $data"?: IssueFocusScreen_widgetIssueOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueFocusScreen_widgetIssueOverview">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueFocusScreen_widgetIssueOverview",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "issues",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetIssueOverviewList_issue"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IssueFocusDetailComponent_issue"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "IssueImagePreloader_issues"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetIssueOverview",
  "abstractKey": null
};
})();

(node as any).hash = "707efe601875558e5b0559e64a25297e";

export default node;
